import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { BrandPageSearch } from "@faire/retailer-visitor-shared/views/brand/BrandPageSearch";
import { BRAND_CART_WIDTH_WIDE } from "@faire/retailer-visitor-shared/views/brand/consts";
import { Opacity } from "@faire/web--source/slate/Color";
import { InputWrapper } from "@faire/web--source/slate/Input";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import React from "react";
import styled, { css } from "styled-components";
export var LinkFormatting = function(chunks, linkTo) {
    return /*#__PURE__*/ _jsx(EmbeddedLink, {
        linkTo: linkTo,
        children: chunks
    });
};
export var MakerContainer = styled.div.withConfig({
    componentId: "sc-4a527486-0"
})([
    "width:100%;",
    "{width:calc(100% - ",
    ");}",
    "{width:calc(100% - ",
    ");}"
], responsiveMediaQueries.desktop, BRAND_CART_WIDTH_WIDE.large, responsiveMediaQueries.xLargeAndAbove, BRAND_CART_WIDTH_WIDE.xlarge);
export var commonPaddingStyle = function(extraPadding, noPadding) {
    if (noPadding) {
        return "";
    }
    return css([
        "padding:",
        ";",
        "{padding:",
        ";}@media (min-width:1680px){padding:0;}"
    ], getSpacing(0, "2x"), responsiveMediaQueries.tabletAndAbove, extraPadding ? getSpacing(0, "5x") : getSpacing(0, "3x", 0, "5x"));
};
export var ContentContainer = styled.div.withConfig({
    componentId: "sc-4a527486-1"
})([
    "width:100%;",
    ""
], function(param) {
    var extraPadding = param.$extraPadding, noPadding = param.$noPadding;
    return commonPaddingStyle(extraPadding, noPadding);
});
export var BrandComponentLowerContainer = styled(Column).withConfig({
    componentId: "sc-4a527486-2"
})([
    "width:100%;max-width:calc(1280px + 80px);margin:0 auto;padding:",
    ";",
    "{padding:",
    ";}"
], getSpacing(0, "5x"), responsiveMediaQueries.mobile, getSpacing(0, "2x"));
export var lowerStyle = function(val) {
    return css([
        "& > div:first-child{padding-top:",
        ";}& > div:last-child{padding-bottom:",
        ";}& > div:not(:first-child){border-top:1px solid ",
        ";padding-top:",
        ";margin-top:",
        ";}"
    ], getSpacing(val), getSpacing(val), Core.border.muted, getSpacing(val), getSpacing(val));
};
export var BrandPageLowerPart = styled.div.withConfig({
    componentId: "sc-4a527486-3"
})([
    "",
    "{",
    "}",
    "{",
    "}",
    "{",
    "}"
], responsiveMediaQueries.mobile, lowerStyle("3x"), responsiveMediaQueries.tablet, lowerStyle("4x"), responsiveMediaQueries.desktopAndAbove, lowerStyle("5x"));
export var InputSearch = styled(BrandPageSearch).withConfig({
    componentId: "sc-4a527486-4"
})([
    "",
    "{border-radius:40px;",
    "{background-color:",
    ";border:none;}",
    "{min-width:300px;}}"
], InputWrapper, responsiveMediaQueries.mobile, Core.surface.subdued + Opacity.O_50, responsiveMediaQueries.tablet);
